import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-toggle", { 'c-toggle--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-toggle__switch", { 'c-toggle__switch--active': _ctx.modelValue }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "c-toggle__circle" }, null, -1)
    ]), 2),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["c-toggle__label", { 'c-toggle__label--disabled': _ctx.disabled }])
        }, _toDisplayString(_ctx.label), 3))
      : _createCommentVNode("", true)
  ], 2))
}